<script>
import L from "leaflet";
import {
  LMap,
  //LPolyline,
  LMarker,
  LIcon,
  LTooltip,
  LTileLayer,
  LLayerGroup,
  //LControlLayers,
  LControl,
} from "vue2-leaflet";
//import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
/**
 * Map component
 */

export default {
  props: [
    "dataPost",
    "dataNext",
    "postNotNear",
    "loader"
  ],
  mounted() {
    
    this.dataPost.map((obj)=>{
      if(obj.lat != "None" && obj.lon != "None")
        this.dataPostF.push({...obj, status: true});
    })
    this.dataNext.map((obj) => {
      if(obj.lat > 20 && obj.lat < 36 && obj.lon > -17 && obj.lon < -1)
        this.dataNextF.push({...obj, status: true});
    });
    this.postNotNear.map((obj) => {
      if(obj.lat != "None" && obj.lon != "None")
        this.postNotNearF.push({...obj, status: true});
    });
  },
  components: {
    LMap,
    LMarker,
    LIcon,
    LTooltip,
    LTileLayer,
    LLayerGroup,
    //LControlLayers,
    LControl,
    //"l-marker-cluster": Vue2LeafletMarkerCluster,
  },
  data() {
    return {
      filterType: 1,
      noFilter: null,
      serialFilter: null,
      filterStatus: false,
      mapZoom: 6,
      mapCenter: [27.105314, -7.684968],

      dataPostF: [],
      dataNextF: [],
      postNotNearF: [],

      icon: L.icon({
        iconUrl: require("@/assets/images/iconDevice.svg"),
        iconSize: [41, 41],
        iconAnchor: [16, 37],
      }),

      clusterOptions: {
        showCoverageOnHover: false,
      },

      imageDevice: require("@/assets/images/iconDevice.svg"),

      imageDataPost: require("./img/posteIcon.svg"),
      imageDataNext: require("./img/nextIcon.svg"),
      imagePostNotNear: require("./img/notNearIcon.svg"),
      
      imageDataPostGray: require("./img/posteIconGrey.svg"),
      imageDataNextGrey: require("./img/nextIconGrey.svg"),
      imagePostNotNearGrey: require("./img/notNearIconGrey.svg"),

      url: "http://{s}.google.com/vt/lyrs=m&gl=ma&x={x}&y={y}&z={z}",
      
      imageClear: require("@/assets/images/clearmap.svg"),
      imageReset: require("@/assets/images/resetzoom.svg"),
      zoomIn: require("@/assets/images/zoomin.svg"),
      zoomOut: require("@/assets/images/zoomout.svg"),

      staticAnchor: [16, 10],
      iconAnchor: [10, 30],
      iconSize: [40, 40],
      tooltipAnchor: [0, -30],

      statusDataPost: true,
      statusDataNext: true,
      statusPostNotNear: true,

    };
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15];
    },
  },
  methods: {
    setZoomIn() {
      this.mapZoom = this.mapZoom + 1;
    },
    setZoomOut() {
      this.mapZoom = this.mapZoom - 1;
    },
    setResetZoom() {
      let center = [27.105314, -7.684968];
      const mapComponent = this.$refs.map;
      let start = center;
      let end = center;
      mapComponent.fitBounds([start, end], { maxZoom: 6 });
    },
    updateZoom(event) {
      this.mapZoom = event;
    },

    changeStatusDataPost() {
      this.statusDataPost == true ? this.statusDataPost = false : this.statusDataPost = true
    },
    changeStatusDataNext() {
      this.statusDataNext == true ? this.statusDataNext = false : this.statusDataNext = true
    },
    changeStatusPostNotNear() {
      this.statusPostNotNear == true ? this.statusPostNotNear = false : this.statusPostNotNear = true
    },

    makeToast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
  },
  watch: {
    
  },
  
  
  beforeDestroy() {
    //this.$refs.map.removeLayer(this.$refs.markerCluster)
  },
};
</script>

<template>
  <div>
    <div
      v-if="loader == true"
      class="loaderDiv d-flex justify-content-center align-items-center"
    >
      <b-spinner
        label="Loading..."
        variant="primary"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>

    <div style="height: 100%">

      <l-map
        style="height: 120vh"
        ref="map"
        :zoom="mapZoom"
        v-on:update:zoom="updateZoom($event)"
        :min-zoom="5"
        :options="{ zoomControl: false }"
        :center="mapCenter"
      >
        <l-tile-layer :url="url" :subdomains="['mt0', 'mt1', 'mt2', 'mt3']" />

        <l-layer-group :visible="statusDataPost" layerType="overlay" name="PNI">
          <l-marker
            :zIndexOffset="100"
            v-for="(marker, index) in dataPostF.filter((obj)=> obj.status == true)"
            :key="index"
            :draggable="false"
            :lat-lng="{ lat: marker.lat, lng: marker.lon }"
            :icon="icon"
          >
            <l-icon
              :icon-anchor="iconAnchor"
              :icon-size="iconSize"
              :tooltipAnchor="tooltipAnchor"
              :icon-url="imageDevice"
            >
              <img :src="imageDataPost" />
            </l-icon>
            <l-tooltip
              class="rounded text-secondary"
              :options="{
                interactive: 'true',
                direction: 'top',
              }"
            >
              <span style="font-weight: 550"
                >{{ $t("tooltips.name.text") }} :
              </span>
              {{ marker.name }}
            </l-tooltip>
          </l-marker>
        </l-layer-group>

        <l-layer-group :visible="statusDataNext" layerType="overlay" name="Serum">
          <l-marker
            :zIndexOffset="100"
            v-for="(marker, index) in dataNextF.filter((obj)=> obj.status == true)"
            :key="index"
            :draggable="false"
            :lat-lng="{ lat: marker.lat, lng: marker.lon }"
            :icon="icon"
          >
            <l-icon
              :icon-anchor="iconAnchor"
              :icon-size="iconSize"
              :tooltipAnchor="tooltipAnchor"
              :icon-url="imageDevice"
            >
              <img :src="imageDataNext" />
            </l-icon>
            <l-tooltip
              class="rounded text-secondary"
              :options="{
                interactive: 'true',
                direction: 'top',
              }"
            >
              <div>
                <span style="font-weight: 550"
                  >{{ $t("tooltips.name.text") }} :
                </span>
                {{ marker.name }}
              </div>
            </l-tooltip>
          </l-marker>
        </l-layer-group>

         <l-layer-group
          :visible="statusPostNotNear"
          layerType="overlay"
          name="Vaccin Covid 19"
        >
          <l-marker
            :zIndexOffset="100"
            v-for="(marker, index) in postNotNearF.filter((obj)=> obj.status == true)"
            :key="index"
            :draggable="false"
            :lat-lng="{ lat: marker.lat, lng: marker.lon }"
            :icon="icon"
          >
            <l-icon
              :icon-anchor="iconAnchor"
              :icon-size="iconSize"
              :tooltipAnchor="tooltipAnchor"
              :icon-url="imageDevice"
            >
              <img :src="imagePostNotNear" />
            </l-icon>
            <l-tooltip
              class="rounded text-secondary"
              :options="{
                interactive: 'true',
                direction: 'top',
              }"
            >
              <div>
                <span style="font-weight: 550"
                  >{{ $t("tooltips.name.text") }} :
                </span>
                {{ marker.name }}
              </div>
            </l-tooltip>
          </l-marker>
        </l-layer-group>

        <l-control>
          <div style="background: rgba(255, 255, 255, 0.4)">
            <span
              class="font-weight-bold"
              style="cursor: pointer"
              @click="changeStatusDataPost"
              ><img v-if="statusDataPost" :src="imageDataPost" width="30" />
              <img v-if="!statusDataPost" :src="imageDataPostGray" width="30" />Agences ABB</span
            ><br />
            <span
              class="font-weight-bold"
              style="cursor: pointer"
              @click="changeStatusDataNext"
              ><img v-if="statusDataNext" :src="imageDataNext" width="30" />
              <img v-if="!statusDataNext" :src="imageDataNextGrey" width="30" />Nextrack</span
            ><br />
            <span
              class="font-weight-bold"
              style="cursor: pointer"
              @click="changeStatusPostNotNear"
              ><img v-if="statusPostNotNear" :src="imagePostNotNear" width="30" />
              <img v-if="!statusPostNotNear" :src="imagePostNotNearGrey" width="30" />Agences ABB proposées</span
            ><br />
          </div>
        </l-control>
      </l-map>
    </div>
  </div>
</template>
<style scoped>
.loaderDiv {
  position: absolute;
  z-index: 5000;
  width: 100%;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
  background: rgba(255, 255, 255, 0.4);
}
</style>